import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useBlockUserMutation } from "../../redux/userApi";

import { useTranslation } from "react-i18next";

function BlockUser({ show, onHide, user }) {
    const { t } = useTranslation();
    const [blockUser] = useBlockUserMutation();

    const handleBlockConfirm = async () => {
        if (!user) return;
        const newStatus = user.status === "active" ? "deleted" : "active";
        await blockUser({ id: user.id, status: newStatus });
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{t('confirm_action')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {user?.status === "active" ? t('confirm_block_user') : t('confirm_unblock_user')}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t('cancel')}
                </Button>
                <Button variant="primary" onClick={handleBlockConfirm}>
                    {t('confirm')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default BlockUser;
